import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
        marginTop: 12
    },
    reportTitle:{
        fontSize: 12,
        textAlign: 'center',
    }
  });


  const ShareCertificateFooter = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>IMPORTANT:
            Please note that the constitution imposes restrictions to transfer these shares and this certificate must
            be attached to application to transfer any shares comprised therein.
        </Text>
    </View>
  );
  
  export default ShareCertificateFooter